const url = '/bankAccounts';
const Provider = 'BankAccounts';
const dbModel = 'BankAccounts';

export { url, Provider, dbModel };
